import React from "react";

const dashboardContext = React.createContext({
    isMobile: false,
    favAddress: {},
    setFavAddress: (item) => {},


})

export default dashboardContext;